import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListExperiments = _resolveComponent("ListExperiments")!

  return (_openBlock(), _createBlock(_component_ListExperiments, {
    expType: _ctx.expType,
    folderId: _ctx.folderId
  }, null, 8, ["expType", "folderId"]))
}